import { useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { setDataInsertNull, updateUser } from '../../store/auth/slice';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Password } from 'primereact/password';

const ModelEditUser = ({ visible, onHide, toast, permission, rowData }) => {
  const dispatch = useDispatch();

  const { dataUpdateUser, errorUpdateUser } = useSelector(
    (state) => ({
      dataUpdateUser: state.Auth.dataUpdateUser,
      errorUpdateUser: state.Auth.errorUpdateUser,
    }),
    shallowEqual
  );

  const validationSchema = Yup.object({
    name: Yup.string().required('Tên người dùng không được để trống'),
    email: Yup.string()
      .required('Tên đăng nhập không được để trống')
      .min(6, 'Tên đăng nhập phải có ít nhất 6 ký tự'),
    password: Yup.string()
      .required('Mật khẩu không được để trống')
      .min(6, 'Mật khẩu phải có ít nhất 6 ký tự'),
    groupPermissionId: Yup.string().required('Vui lòng chọn quyền người dùng'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: rowData ? rowData.name : '',
      email: rowData ? rowData.email : '',
      password: rowData ? rowData.password : '',
      groupPermissionId:
        rowData && rowData.GroupPermissions?.length > 0
          ? rowData.GroupPermissions[0].id
          : null,
      note: rowData && rowData.note ? rowData.note : '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      dispatch(updateUser({ id: rowData.id, data: values }));
    },
  });

  useEffect(() => {
    if (dataUpdateUser) {
      toast.current.show({
        severity: 'success',
        summary: 'Thành công',
        detail: 'Cập nhật người dùng thành công',
        life: 3000,
      });
      formik.resetForm();
      dispatch(setDataInsertNull());
      onHide();
    }
  }, [dataUpdateUser]);

  useEffect(() => {
    if (errorUpdateUser) {
      toast.current.show({
        severity: 'error',
        summary: 'Thất bại',
        detail: errorUpdateUser.response.data.message,
        life: 3000,
      });
      dispatch(setDataInsertNull());
    }
  }, [errorUpdateUser]);

  return (
    <Dialog
      visible={visible}
      onHide={() => {
        formik.resetForm();
        onHide();
      }}
      header='Sửa người dùng'
      modal
      style={{ width: '450px', minHeight: '55%' }}
      footer={
        <div>
          <Button
            label='Hủy'
            onClick={() => {
              formik.resetForm();
              onHide();
            }}
            severity='secondary'
            className='p-button-text'
          />
          <Button
            type='submit'
            label='Lưu'
            onClick={formik.handleSubmit}
          />
        </div>
      }>
      <form onSubmit={formik.handleSubmit}>
        <div className='bg-white border-round-md'>
          <div className='flex flex-column gap-3'>
            <div className='flex flex-column w-full '>
              <label className='mb-2'>Tên hiển thị</label>
              <InputText
                id='name'
                name='name'
                value={formik.values.name}
                onChange={formik.handleChange}
                style={{ height: '40px' }}
                invalid={
                  formik.touched.name && formik.errors.name ? true : false
                }
              />
              {formik.touched.name && formik.errors.name ? (
                <div style={{ color: 'red', marginTop: '3px' }}>
                  {formik.errors.name}
                </div>
              ) : null}
            </div>
            <div className='flex flex-column w-full'>
              <label className='mb-2'>Tên đăng nhập</label>
              <InputText
                id='email'
                name='email'
                value={formik.values.email}
                onChange={formik.handleChange}
                style={{ height: '40px' }}
                invalid={
                  formik.touched.email && formik.errors.email ? true : false
                }
              />
              {formik.touched.email && formik.errors.email ? (
                <div style={{ color: 'red', marginTop: '3px' }}>
                  {formik.errors.email}
                </div>
              ) : null}
            </div>
            <div className='flex flex-column w-full'>
              <label className='mb-2'>Mật khẩu</label>
              <Password
                value={formik.values.password}
                onChange={formik.handleChange}
                id='password'
                name='password'
                type='password'
                placeholder='Mật khẩu'
                autoComplete='on'
                inputClassName='w-full'
                inputStyle={{ height: '40px' }}
                pt={{
                  iconField: {
                    root: { className: 'w-full' },
                  },
                }}
                toggleMask
                feedback={false}
                invalid={
                  formik.touched.password && formik.errors.password
                    ? true
                    : false
                }
              />
              {formik.touched.password && formik.errors.password ? (
                <div style={{ color: 'red', marginTop: '3px' }}>
                  {formik.errors.password}
                </div>
              ) : null}
            </div>
            <div className='flex flex-column w-full'>
              <label className='mb-2'>Chọn nhóm quyền</label>
              <Dropdown
                id='groupPermissionId'
                name='groupPermissionId'
                value={formik.values.groupPermissionId}
                options={permission}
                emptyMessage='Không có dữ liệu'
                placeholder='Chọn nhóm quyền'
                onChange={formik.handleChange}
                style={{ height: '40px' }}
                optionLabel='groupName'
                optionValue='id'
                className={`${
                  !formik.touched.groupPermissionId ||
                  !formik.errors.groupPermissionId
                    ? 'border-300'
                    : 'border-red-500'
                } flex align-items-center`}
                invalid={
                  formik.touched.groupPermissionId &&
                  formik.errors.groupPermissionId
                    ? true
                    : false
                }
              />
              {formik.touched.groupPermissionId &&
              formik.errors.groupPermissionId ? (
                <div style={{ color: 'red', marginTop: '3px' }}>
                  {formik.errors.groupPermissionId}
                </div>
              ) : null}
            </div>
            <div className='flex flex-column w-full'>
              <label className='mb-2'>Ghi chú</label>
              <InputTextarea
                id='note'
                name='note'
                autoResize
                value={formik.values.note}
                onChange={formik.handleChange}
                style={{ height: '40px' }}
              />
            </div>
          </div>
        </div>
      </form>
    </Dialog>
  );
};

export default ModelEditUser;
